export enum DriversLicenseScannerConstants {
  LOAD_WASM = 'dlScanner/LOAD_WASM',
  APPEND_MESSAGE = 'dlScanner/APPEND_MESSAGE',
  SET_LIB_LOADED = 'dlScanner/SET_LIB_LOADED',
  SET_RESULT_VALUE = 'dlScanner/SET_RESULT_VALUE',
  SET_RESULT_ITEMS = 'dlScanner/SET_RESULT_ITEMS',
  SET_SHOW_SCANNER = 'dlScanner/SET_SHOW_SCANNER',
  SET_LICENSE_INFO = 'dlScanner/SET_LICENSE_INFO',
  TOGGLE_ALL_DRIVERS_LICENSE_KEYS = 'dlScanner/TOGGLE_ALL_DRIVERS_LICENSE_KEYS',
  TOGGLE_DRIVERS_LICENSE_KEY = 'dlScanner/TOGGLE_DRIVERS_LICENSE_KEY',
  SET_DRIVERS_LICENSE_KEYS = 'dlScanner/SET_DRIVERS_LICENSE_KEYS',
  IMPORT_DRIVERS_LICENSE_INFO = 'dlScanner/IMPORT_DRIVERS_LICENSE_INFO',
}

export const ToggleKeyConstants = [
  'DAC',
  'DCS',
  'DAD',
  'DAQ',
  'DBB',
  'DBC',
  'DAU',
  'DAG',
  'DAI',
  'DAJ',
  'DAK',
  'DCG',
  'DAW',
]
